/** null when the key is missing or its value is not valid JSON. */
export const getParsedLocalStorageItem = (key: string) => {
    const localStorageJSON = localStorage.getItem(key);
    if (!localStorageJSON) return null;

    try {
        return JSON.parse(localStorageJSON);
    } catch {
        return null;
    }
};

/** {} when the key is missing or holds no object. */
export const getParsedLocalStorageRecord = <T extends object>(key: string): T => {
    const parsed = getParsedLocalStorageItem(key);
    return parsed && typeof parsed === "object" ? parsed : ({} as T);
};
